﻿module Client.ContractPage.CostOfConstruction.Expanded.PoSl

open FSharpPlus
open System
open Client
open Fable.React
open Fable.React.Props
open PortalLibs.Shared
open PortalLibs.Client.Util
open Client.ContractPage.CostOfConstruction.Expanded
open Model
open Fulma
open Shared
open Feliz
open Client.ContractPage.CostOfConstruction.Utils

let poSlTableView (costSubs: JobCostSub list) typeStr =
  tr [ Style [ FontSize Config.smallTextSize ] ] [
    td [ ColSpan 8 ] [
      div [ Style [
              Display DisplayOptions.Flex
              JustifyContent "center"
              OverflowY OverflowOptions.Auto
              Padding "15px 0"
            ] ] [
        Table.table [ Table.IsHoverable ] [
          thead [] [
            tr [] [
              th [ Style [
                     TextAlign TextAlignOptions.Right
                     Width "100px"
                   ] ] [
                str typeStr
              ]
              th [ Style [ Width "250px" ] ] [
                str "Vendor"
              ]
              th [ Style [
                     TextAlign TextAlignOptions.Right
                     Width "140px"
                   ] ] [
                $"%s{typeStr} Amt" |> str
              ]
              th [ Style [
                     TextAlign TextAlignOptions.Right
                     Width "160px"
                   ] ] [
                str "Actual Cost"
              ]
            ]
          ]
          tbody [] [
            yield!
              costSubs
              |>> fun cost ->
                tr [] [
                  td [ Style alignRight ] [
                    cost.Number |> emptyStrTagIfNone
                  ]
                  td [] [
                    cost.Vendor |> emptyStrTagIfNone
                  ]
                  td [ Style alignRight ] [
                    cost.Amount
                    |> DisplayNumber.AsCurrency.stdStr
                  ]
                  td [ Style alignRight ] [
                    cost.Cost
                    |> DisplayNumber.AsCurrency.stdStr
                  ]
                ]
            if costSubs.Length > 1 then
              yield
                tr [] [
                  td [] []
                  td [ Style alignRight ] [
                    strong [] [
                      $"%s{typeStr} Total:" |> str
                    ]
                  ]
                  td [ Style alignRight ] [
                    strong [] [
                      costSubs
                      |> List.sumBy (fun c -> c.Amount)
                      |> DisplayNumber.AsCurrency.stdStr
                    ]
                  ]
                  td [ Style alignRight ] [
                    strong [] [
                      costSubs
                      |> List.sumBy (fun c -> c.Cost)
                      |> DisplayNumber.AsCurrency.stdStr
                    ]
                  ]
                ]
          ]
        ]
      ]
    ]
  ]
let View =
  React.memo (
    "PoSlView",
    (fun (props: {| costs: Map<JobCostId, JobCostSub list>
                    costId: JobCostId
                    subType: JobCostSubType
                    Key: string |}) ->
      match Map.tryFind props.costId props.costs with
      | None -> nothing
      | Some costs ->
        match costs
              |> List.filter (fun c -> c.Type = props.subType)
          with
        | [] -> nothing
        | costSubs ->
          poSlTableView
            costSubs
            (match props.subType with
             | JobCostSubType.SL -> "SL"
             | JobCostSubType.PO -> "PO"
             | _ -> ArgumentOutOfRangeException() |> raise)),
    (fun (props: {| costs: Map<JobCostId, JobCostSub list>
                    costId: JobCostId
                    subType: JobCostSubType
                    Key: string |}) -> $"PoSlView-%s{props.Key}")
  )


  